import React from 'react';
import { useNavigate } from 'react-router-dom';

interface PageHeaderNewProps {
  title: string;
  subtitle?: string;
  backUrl?: string;
  onBack?: () => void;
  className?: string;
}

export function PageHeaderNew({ title, subtitle, backUrl, onBack, className = 'mb-6' }: PageHeaderNewProps) {
  const navigate = useNavigate();

  const handleBack = () => {
    if (onBack) {
      onBack();
    } else if (backUrl) {
      navigate(backUrl);
    }
  };

  return (
    <div className={`flex items-center gap-4 ${className}`}>
      {(backUrl || onBack) && (
        <button 
          onClick={handleBack}
          className="w-10 h-10 flex items-center justify-center rounded-full text-emerald-600 hover:text-emerald-700 hover:bg-emerald-50 transition-all active:scale-95 shrink-0"
        >
          <i className="ri-arrow-left-line text-2xl" />
        </button>
      )}
      <div>
        <h1 className="text-xl font-medium text-slate-900 tracking-tight">{title}</h1>
        {subtitle && <p className="text-sm font-normal text-slate-500 mt-0.5">{subtitle}</p>}
      </div>
    </div>
  );
}
